import { render, staticRenderFns } from "./TablaDePedidos.vue?vue&type=template&id=22217ad1&scoped=true"
import script from "./TablaDePedidos.vue?vue&type=script&lang=js"
export * from "./TablaDePedidos.vue?vue&type=script&lang=js"
import style0 from "./TablaDePedidos.vue?vue&type=style&index=0&id=22217ad1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22217ad1",
  null
  
)

export default component.exports